export const extractEsPersonId = (esPersonId: string) => {
  const firstHyphenIndex = esPersonId.indexOf('-');

  if (firstHyphenIndex === -1) {
    return esPersonId;
  }

  return esPersonId.slice(firstHyphenIndex + 1);
};
